// extracted by mini-css-extract-plugin
export var modalFooter = "_j8-0";